module.exports = __webpack_public_path__ + "img/cally-and-gerek.483d56f3.jpg";